<template>
    <tr v-if="!appointment.separator">
        <td>
            <div class="row">
                <div class="col-sm-2 col-xs-4">
                    {{ getHourString(appointment.date) }}-{{ getHourString(appointment.end_date) }}
                </div>
                <div class="col-sm-10 col-xs-8 margin-bottom-10">
                    <div class="row">
                        <div class="col-md-3">
                            {{ appointment.chaired_admin_name }}
                        </div>
                        <div class="col-md-3 bold">
                            {{ appointment.rate_name }}
                        </div>
                        <div class="col-md-3">

                            <a v-if="appointment.reservation_count > 0" href=""
                               @click.prevent.stop="$emit('open-partecipants-modal', appointment.id)">
                                <span>{{
                                        $t('components.appointment_admin.participants', {reservation_count: appointment.reservation_count})
                                    }}</span>
                            </a>
                            <span v-else class="text-muted">{{
                                    $t('components.appointment_admin.no_participants')
                                }}</span>

                        </div>
                        <div class="col-md-3">
                            <span v-if="appointment.is_online" class="label label-default">{{
                                    $t('common.online')
                                }}</span>
                            <span v-else-if="appointment.location">
                                <a :href=locationHref target="_blank">{{appointment.location.name}}</a>
                            </span>
                            <span v-else>{{ $t('common.in_studio') }}</span>
                        </div>
                    </div>
                </div>
                <div class="col-sm-2 col-sm-offset-0 col-xs-8 col-xs-offset-4" v-if="!inPast">
                    <a v-if="appointment.is_online" href="" class="btn btn-primary btn-block-xs"
                       @click.prevent.stop="startLessonClick">
                        <i class="las la-video"></i>{{ $t('components.appointment_admin.start_lesson') }}
                    </a>
                </div>
                <SpinnerLoader v-show="loading"></SpinnerLoader>
            </div>
        </td>
    </tr>
    <tr v-else class="row-title">
        <td style="border:none;text-transform: uppercase;" colspan="5"><b>{{ appointment.separator_name }}</b></td>
    </tr>
</template>

<script>
import {Utils} from "../../common/utils";
import {getAppointmentDetail} from "../../api";
import SpinnerLoader from "../common/SpinnerLoader";

export default {
    name: "AppointmentsAdminRow",
    props: {
        appointment: {
            type: Object,
            require: true
        },
        inPast: {
            type: Boolean,
            default: false
        }
    },
    components: {SpinnerLoader},
    data: () => {
        return {
            loading: false,
        }
    },

    computed: {
        locationHref: function () {

            if (this.appointment.location) {
                return "https://www.google.com/maps/place/" + this.appointment.location.latitude +"," +  this.appointment.location.longitude
            }

            return ""

        }
    },
    methods: {
        getHourString(date) {
            return Utils.getHourStringFromISO(date)
        },
        async startLessonClick() {
            if (this.appointment.meeting_start_url) {
                window.open(this.appointment.meeting_start_url, "_blank");
            } else {
                this.loading = true;
                try {
                    let appointmentDetail = await getAppointmentDetail(this.appointment.id);
                    console.log(appointmentDetail)
                    if (appointmentDetail.zoom_start_url) {
                        window.open(appointmentDetail.zoom_start_url, "_blank");
                    }
                    this.loading = false;
                } catch (e) {
                    console.log(e);
                    this.loading = false;
                }
            }
        },
    }
}
</script>
